export const TABLE_SIZE_UNITS_PER_REM = 10;
export const TABLE_WIDTH_STYLE_DECIMAL_PLACES = 4;
export const TABLE_WIDTH_STYLE_ROUNDING_FACTOR = 10 ** TABLE_WIDTH_STYLE_DECIMAL_PLACES;
export const ROW_EXTENSION_COLUMN_WIDTH_REM = 5;
export const STICKY_RIGHT_OFFSET_REM = -0.1;

export const formatRemValue = (value: number): string =>
  `${Math.round(value * TABLE_WIDTH_STYLE_ROUNDING_FACTOR) / TABLE_WIDTH_STYLE_ROUNDING_FACTOR}rem`;
export const formatTableSizeUnitsAsRem = (value: number): string => formatRemValue(value / TABLE_SIZE_UNITS_PER_REM);
export const convertRemToTableSizeUnits = (rem: number): number => Math.ceil(rem * TABLE_SIZE_UNITS_PER_REM);
